import { ChangeEventHandler, Fragment, ReactNode, type JSX } from 'react';
import classNames from 'classnames';
import { Size } from '../../types';
import styles from './styles/styles.module.scss';

type RadioProps = {
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  inputLast?: boolean;
  labelElement: ReactNode;
  name?: string;
  onChange: (value: string) => void;
  selected: boolean;
  size?: Size<'sm' | 'md'>;
  testId: string;
  value: string;
  verticalAlignment?: 'center' | 'top';
};

const Radio = ({
  autoFocus,
  className,
  disabled,
  inputLast,
  labelElement,
  name,
  onChange,
  selected,
  size = 'md',
  testId,
  value,
  verticalAlignment = 'center'
}: RadioProps): JSX.Element => {
  const onInputChange: ChangeEventHandler<HTMLInputElement> = () => {
    onChange(value);
  };

  const labelWrapper = <Fragment key={`label-${value}`}>{labelElement}</Fragment>;

  const radioElement = (
    <Fragment key={`radio-${value}`}>
      <input
        autoFocus={autoFocus}
        checked={selected === true}
        disabled={disabled}
        name={name}
        onChange={onInputChange}
        type="radio"
        data-testid={testId}
        value={value}
        aria-labelledby={value}
      />
      <div aria-hidden="true" className={styles.radio} />
    </Fragment>
  );

  const elements = inputLast ? [labelWrapper, radioElement] : [radioElement, labelWrapper];

  return (
    <label
      id={value}
      className={classNames(
        className,
        styles.container,
        styles[size],
        styles[verticalAlignment],
        disabled && styles.disabled,
        inputLast && styles.inputLast
      )}
    >
      {elements}
    </label>
  );
};

export default Radio;
